import { useState } from 'react';
import Modal from './Modal.jsx';

/**
 * One-time secret reveal. The raw API key is NEVER retrievable again after this response, so
 * this stays open until the operator explicitly confirms they've copied it — no auto-dismiss,
 * no dismiss-by-clicking-outside, no toast that could vanish before it's read.
 */
export default function ApiKeyRevealModal({ title, apiKey, onClose }) {
  const [copied, setCopied] = useState(false);
  const [confirmed, setConfirmed] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(apiKey);
      setCopied(true);
    } catch {
      // Clipboard API can be unavailable/blocked — the key is still selectable text in the box
      // below, so this isn't fatal, just less convenient.
    }
  }

  return (
    <Modal
      title={title}
      onClose={confirmed ? onClose : undefined}
      dismissible={false}
      footer={
        <label className="apikey-reveal__confirm">
          <input type="checkbox" checked={confirmed} onChange={(e) => setConfirmed(e.target.checked)} />
          <span>I've copied this key somewhere safe</span>
          <button className="btn btn--primary" disabled={!confirmed} onClick={onClose} style={{ marginLeft: 'auto' }}>
            Done
          </button>
        </label>
      }
    >
      <div className="apikey-reveal">
        <div className="apikey-reveal__warning">
          <strong>This key will never be shown again.</strong> Copy it now and store it securely — if it's
          lost, you'll need to rotate the key to issue a new one.
        </div>
        <div className="apikey-reveal__box">
          <code>{apiKey}</code>
          <button type="button" className="btn btn--ghost btn--sm" onClick={copy}>
            {copied ? 'Copied ✓' : 'Copy'}
          </button>
        </div>
      </div>
    </Modal>
  );
}
